export default {
  // Auth Endpoints
  sharedBlogsEndpoint: '/blogs',
  sharedEventsEndpoint: '/events'
}
